// src/Hero.js

import React from 'react';
import './Hero.css';
import advaitPhoto from './advait.jpg';

const Hero = ({ name, age }) => {
  return (
    <header className="hero">
      <div className="hero-portrait">
        <img className="hero-photo" src={advaitPhoto} alt={`${name}, the birthday boy`} />
        <span className="hero-badge" aria-hidden="true">{age}</span>
      </div>
      <h1 className="hero-heading">{name} is turning {age}</h1>
      <p className="hero-sub">Come bounce with us at Pump It Up</p>
    </header>
  );
};

export default Hero;
